import { render } from "./LoggedInTemplate.vue?vue&type=template&id=6df32818&scoped=true"
import script from "./LoggedInTemplate.vue?vue&type=script&lang=ts"
export * from "./LoggedInTemplate.vue?vue&type=script&lang=ts"

import "./LoggedInTemplate.vue?vue&type=style&index=0&id=6df32818&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6df32818"

export default script